import client from "../../helpers/api";
import mergePath from "../../helpers/mergePath";
import { IPayment } from "./types";

export function getPayments(): Promise<IPayment[]> {
  return client.get(mergePath("api", `/payments`), {});
}
